var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 549,
    viewBox: "0 0 1280 549",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3525_2359",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1280,
    height: 549
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 549,
    fill: "#38C99F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3525_2359)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 549,
    fill: "#38C99F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1047,
    y: 255.344,
    width: 569,
    height: 486,
    rx: 63,
    transform: "rotate(-45 1047 255.344)",
    fill: "#BEFFEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1047,
    y: 397.344,
    width: 569,
    height: 486,
    rx: 63,
    transform: "rotate(-45 1047 397.344)",
    fill: "#58E3BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -559,
    y: -122.521,
    width: 422.113,
    height: 694.812,
    rx: 63,
    transform: "rotate(-45 -559 -122.521)",
    fill: "#58E3BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingBg);
export default __webpack_public_path__ + "static/media/pricing_bg.adb6edbe0c32362a7726cf553eb1e0ae.svg";
export { ForwardRef as ReactComponent };